const S = require("sweetalert2");

export const ajustarZoom = (a, b, total) => {
  const screen = Math.sqrt(a ** 2 + b ** 2);

  console.log(screen, total);
  const y = 0.4198 * screen ** 0.1118;
  return y;
};

export const calcZoom = (maxDistance, total) => {
  let zoom = 16 - Math.log2(maxDistance);
  if (total) {
    zoom = 16 - Math.log2(total);
  }

  if (zoom === Infinity) return 18;
  return zoom;
};

export const calcularZoom = (rect_width, rect_height, maxDistance) => {
  const { latKm, lngKm } = maxDistance;

  const zoomToKmperPixel = (zl) => {
    // -8,972064E-05x3 + 4,738033E-03x2 - 8,376241E-02x + 4,962492E-01
    const a3 = -8.972064 * 10 ** -5;
    const a2 = 4.738033 * 10 ** -3;
    const a1 = -8.376241 * 10 ** -2;
    const a0 = 4.962492 * 10 ** -1;

    const km = a3 * zl ** 3 + a2 * zl ** 2 + a1 * zl + a0;

    return km;
  };

  const kmperPixelToZoom = (kmperpixel) => {
    // y = 8,762909x-9,233537E-02
    // 8.628909
    return 8.762909 * kmperpixel ** (-9.233537 * 10 ** -2);
  };

  const zLat = kmperPixelToZoom((latKm + 0.1) / rect_height);
  const zLng = kmperPixelToZoom((lngKm + 0.1) / rect_width);

  return Math.min(zLat, zLng);
};

export function haversineDistance(pos1, pos2) {
  const { lat1, lon1 } = pos1;
  const { lat2, lon2 } = pos2;
  const R = 6371; // Radio de la Tierra en km

  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.asin(Math.sqrt(a));

  return R * c; // distancia en km
}

export function getMaxDistanceBetweenPoints(points) {
  try {
    if (!Array.isArray(points) || points.length < 2) {
      return { direction: null, distanceKm: 0 };
    }

    // Iniciar con null para detectar si se cargó al menos un valor válido
    let minLat = null,
      maxLat = null,
      minLng = null,
      maxLng = null;

    let diagonal = haversineDistance(
      { lat1: points[0].latitud, lon1: points[0].longitud },
      { lat2: points[1].latitud, lon2: points[1].longitud }
    );

    for (const p of points) {
      // Intentar leer la coordenada con los nombres más comunes
      let lat = p.latitud;
      let lng = p.longitud;

      // Si vienen como string con coma decimal, la convertimos
      if (typeof lat === "string") lat = Number(lat.replace(",", "."));
      if (typeof lng === "string") lng = Number(lng.replace(",", "."));

      // Verificar que sean números finitos
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;

      // Actualizar extremos
      minLat = minLat === null ? lat : Math.min(minLat, lat);
      maxLat = maxLat === null ? lat : Math.max(maxLat, lat);
      minLng = minLng === null ? lng : Math.min(minLng, lng);
      maxLng = maxLng === null ? lng : Math.max(maxLng, lng);
    }

    // Si no quedó ningún valor válido
    if (
      minLat === null ||
      maxLat === null ||
      minLng === null ||
      maxLng === null
    ) {
      return { direction: null, distanceKm: 0, total: 0 };
    }

    // ► Norte-Sur: ~111.32 km por grado de latitud
    const latKm = (maxLat - minLat) * 111.32;

    // ► Este-Oeste: 111.32 km × cos(lat media) por grado de longitud
    const avgLat = (maxLat + minLat) / 2;
    const lngKm =
      (maxLng - minLng) * 111.32 * Math.cos((avgLat * Math.PI) / 180);

    return latKm > lngKm
      ? {
          direction: "Norte-Sur",
          distanceKm: latKm,
          total: diagonal,
          latKm,
          lngKm,
        }
      : {
          direction: "Este-Oeste",
          distanceKm: lngKm,
          total: diagonal,
          latKm,
          lngKm,
        };
  } catch (err) {
    console.log(err);
    return -1;
  }
}

export async function obtenerUbicacion() {
  try {
    // Verificamos si el navegador soporta geolocalización
    if (!navigator.geolocation) {
      await S.fire("Error", "Tu navegador no soporta geolocalización", "error");
      throw { message: "Geolocalización no soportada" };
    }

    // Verificamos el estado del permiso
    let permiso;
    try {
      const res = await navigator.permissions.query({ name: "geolocation" });
      permiso = res.state;
    } catch (e) {
      permiso = "prompt"; // fallback si no soporta navigator.permissions
    }

    // Si está denegado, avisamos y no seguimos
    if (permiso === "denied") {
      await S.fire(
        "Permiso denegado",
        "El navegador ha denegado permanentemente el acceso a la ubicación. Para utilizar esta función, habilite el permiso correspondiente desde la configuración del navegador",
        "error"
      );
      throw {
        msg: "El navegador ha denegado permanentemente el acceso a la ubicación. Para utilizar esta función, habilite el permiso correspondiente desde la configuración del navegador",
      };
    }

    // Retornamos una promesa con la ubicación
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ lat: latitude, lng: longitude });
        },
        async (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            await S.fire(
              "Permiso denegado",
              "No se puede ejecutar la acción sin permisos de ubicación.",
              "error"
            );
          } else {
            await S.fire(
              "Error",
              "No se pudo obtener la ubicación: " + error.message,
              "error"
            );
          }
          reject(error);
        }
      );
    });
  } catch (err) {
    console.log(err);
    throw err;
  }
}
